"use strict";
import { Route as V2RouteSDK } from "@uniswap/v2-sdk";
import { Route as V3RouteSDK } from "@uniswap/v3-sdk";
import { Route as V4RouteSDK } from "@uniswap/v4-sdk";
import { Protocol } from "./protocol";
import { MixedRouteSDK } from "./mixedRoute/route";
export function getPathToken(currency, pool) {
  if (pool.token0.wrapped.equals(currency.wrapped)) {
    return pool.token0;
  } else if (pool.token1.wrapped.equals(currency.wrapped)) {
    return pool.token1;
  } else {
    throw new Error(`Expected token ${currency.symbol} to be either ${pool.token0.symbol} or ${pool.token1.symbol}`);
  }
}
export class RouteV2 extends V2RouteSDK {
  constructor(v2Route) {
    super(v2Route.pairs, v2Route.input, v2Route.output);
    this.protocol = Protocol.V2;
    this.pools = this.pairs;
    this.pathInput = getPathToken(v2Route.input, this.pairs[0]);
    this.pathOutput = getPathToken(v2Route.output, this.pairs[this.pairs.length - 1]);
  }
}
export class RouteV3 extends V3RouteSDK {
  constructor(v3Route) {
    super(v3Route.pools, v3Route.input, v3Route.output);
    this.protocol = Protocol.V3;
    this.path = v3Route.tokenPath;
    this.pathInput = getPathToken(v3Route.input, this.pools[0]);
    this.pathOutput = getPathToken(v3Route.output, this.pools[this.pools.length - 1]);
  }
}
export class RouteV4 extends V4RouteSDK {
  constructor(v4Route) {
    super(v4Route.pools, v4Route.input, v4Route.output);
    this.protocol = Protocol.V4;
    this.path = v4Route.currencyPath;
  }
}
export class MixedRoute extends MixedRouteSDK {
  constructor(mixedRoute) {
    super(mixedRoute.pools, mixedRoute.input, mixedRoute.output);
    this.protocol = Protocol.MIXED;
  }
}
